

   // const IP =            'http://localhost:3002/api_www/';
   // const IP_SOCKET =     "http://localhost:3002"

// const IP =            'http://192.168.0.195:3002/api_www/';
//    const IP_SOCKET =     "http://192.168.0.195:3002"

//  const IP = 'https://planer.artdruk.eu:3443/api_www/';
//     const IP_SOCKET = "https://planer.artdruk.eu:3443"

//  .env.development.local
//  .env.production.locl

const IP = process.env.REACT_APP_IP;
const IP_SOCKET = process.env.REACT_APP_IP_SOCKET;

console.log("Aktualny adres API:", IP);
console.log("Aktualny adres SOCKET:", IP_SOCKET);


export  {   IP,IP_SOCKET}